import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { LightDiagnosticCalculatePlanForm } from '@/modules/lightdiagnostic/models/LightDiagnosticCalculatePlanForm';
import { LightDiagnosticSubmission } from '@/modules/lightdiagnostic/models/LightDiagnosticSubmission';

export class LightDiagnosticResource extends BaseResource {
  calculateBillingPlan(params: Params = {}): Promise<LightDiagnosticCalculatePlanForm> {
    return this.postData(Route.LIGHTDIAGNOSTIC_CALCULATEBILLINGPLAN, params);
  }

  syncSubmissionToHubspot(params: Params = {}): Promise<LightDiagnosticSubmission> {
    return this.postData(Route.LIGHTDIAGNOSTIC_SYNCSUBMISSIONTOHUBSPOT, params);
  }
}

export default new LightDiagnosticResource();
